import React from 'react';
import { Helmet } from 'react-helmet';
import { useLoungeById } from '@/hooks/loungesHooks/loungesHelperHooks';
import { useCommonContent } from '@/hooks/oneCmsIntlHooks/oneCmsIntlHelperHooks';
import { useRouteParams } from '@/context/routeParamsContext';
import { cn, formatText } from '@/helpers/utils';
import LoungeDetailsOverview from './LoungeDetailsOverview';
import LoungeLocationDetails from './LoungeLocationDetails';
import LoungeDetailsOpeningHours from './LoungeDetailsOpeningHours';
import LoungeDetailsAmenitiesList from './LoungeDetailsAmenitiesList';
import LoungeDetailsSidebar from './LoungeDetailsSidebar';
import LoungeImportantInformation from './LoungeImportantInformation';
import styles from './LoungeDetails.module.scss';
import LoungeAirportandTerminal from '../common/LoungeAirportandTerminal';
import LoungeOtherLoungesInTerminal from '../common/LoungeOtherLoungesInTerminal';

const LoungeDetailsContent = () => {
  const { loungeId } = useRouteParams();
  const lounge = useLoungeById(loungeId);

  // for meta description
  const content = useCommonContent();
  const loungeName = lounge.name;
  const airportName = lounge.airport.name;
  const loungeLocation = lounge.location.terminal;
  const loungePage = content?.pageTitles?.lounge;

  return (
    <div
      className={cn(
        'pad-0-t pad-2-r-min-up width-full container',
        styles.maxWidthMatchHeader
      )}
    >
      <Helmet>
        <title>
          {formatText(loungePage?.title, { loungeName, airportName })}
        </title>
        <meta
          name="description"
          content={formatText(loungePage?.description, {
            loungeName,
            airportName,
            loungeLocation,
          })}
        />
      </Helmet>
      <div className="row stack position-relative">
        <div
          id={styles.loungeContentContainer}
          className="col-xs-12 col-sm-12 col-md-6 col-lg-7 col-xl-8 position-static-md-up margin-0-b xl_tw-pl-0"
        >
          <h1 className="tw-heading-lg-book tw-mr-2 tw-pb-1 tw-text-gray-900 md_tw-heading-display-small-book">
            {loungeName}
          </h1>
          <LoungeAirportandTerminal />
          <LoungeDetailsSidebar className="col-xs-12 col-md-5 col-lg-4 col-xl-4 md_tw-hidden" />
          <LoungeDetailsOverview />
          <LoungeDetailsOpeningHours />
          <LoungeLocationDetails />
          <LoungeImportantInformation />
          <LoungeDetailsAmenitiesList />
        </div>
        <LoungeDetailsSidebar className="col-xs-12 col-md-6 col-lg-5 col-xl-4 tw-hidden md_tw-block" />
        <LoungeOtherLoungesInTerminal />
      </div>
    </div>
  );
};

export default LoungeDetailsContent;
